import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ChevronDown, Users, ChevronLeft, ChevronRight } from 'lucide-react';

const VITALIS_LOGO = "https://vitalis-sports.ch/wp-content/uploads/2024/10/Asset-3.png";

const TESTIMONIALS = [
  { name: "Remo", text: "Ich werde immer herzlich und persönlich empfangen. Die Infrastruktur ist zudem sehr innovativ.", image: null },
  { name: "Lisbeth", text: "Dank der Analyse mit dem Cardioscan, konnte ich frühzeitig einem Herz-Kreislaufproblem vorbeugen.", image: null },
  { name: "Fiorina", text: "Ich schätze am Vitalis Fitness besonders die persönliche Betreuung der Fitnesstrainer/innen, die jederzeit möglich ist.", image: null },
  { name: "Gert", text: "Das Team ist persönlich, unkompliziert und sehr sympathisch. Vitalis hat super Öffnungszeiten.", image: null },
  { name: "Giuseppe", text: "Ich bin seit Jahren sehr zufrieden mit dem Vitalis. Das freundliche und kompetente Personal und die Vielfalt an Angeboten wie z. B. Sauna und Tennisplätze machen für mich den Unterschied.", image: null },
];

function TestimonialSlider() {
  const [current, setCurrent] = useState(0);
  const next = () => setCurrent((c) => (c + 1) % TESTIMONIALS.length);
  const prev = () => setCurrent((c) => (c - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
  useEffect(() => { const i = setInterval(next, 5000); return () => clearInterval(i); }, []);

  return (
    <div className="relative">
      <div className="overflow-hidden">
        <div className="flex transition-transform duration-500" style={{ transform: `translateX(-${current * 100}%)` }}>
          {TESTIMONIALS.map((t, i) => (
            <div key={i} className="w-full flex-shrink-0 px-4">
              <div className="max-w-2xl mx-auto text-center">
                <p className="text-xl md:text-2xl text-gray-700 italic mb-6">"{t.text}"</p>
                <div className="flex flex-col items-center">
                  <p className="font-bold text-gray-900 text-lg">{t.name}</p>
                  {t.image && <img src={t.image} alt={t.name} className="w-16 h-16 rounded-full object-cover mt-4" />}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <button onClick={prev} className="absolute left-0 top-1/2 -translate-y-1/2 p-2 bg-white/80 hover:bg-white rounded-full shadow-lg"><ChevronLeft className="h-6 w-6" /></button>
      <button onClick={next} className="absolute right-0 top-1/2 -translate-y-1/2 p-2 bg-white/80 hover:bg-white rounded-full shadow-lg"><ChevronRight className="h-6 w-6" /></button>
      <div className="flex justify-center gap-2 mt-6">
        {TESTIMONIALS.map((_, i) => <button key={i} onClick={() => setCurrent(i)} className={`w-2 h-2 rounded-full ${i === current ? 'bg-orange-500' : 'bg-gray-300'}`} />)}
      </div>
    </div>
  );
}

export default function Wellness() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      {/* Extranet Banner */}
      <div className="bg-[#1e3a5f] text-white py-1.5 px-4 text-xs">
        <div className="max-w-7xl mx-auto flex items-center justify-end gap-3">
          <span className="text-white/70">Mitarbeiter-Bereich</span>
          <Link to="/login" className="flex items-center gap-1.5 bg-orange-500 hover:bg-orange-600 px-3 py-1 rounded text-xs font-medium transition-colors">
            <Users className="h-3 w-3" />
            Extranet
          </Link>
        </div>
      </div>

      {/* Header */}
      <header className="bg-white py-4 px-6 flex items-center justify-between relative z-50 shadow-sm">
        <Link to="/" className="flex items-center">
          <img src={VITALIS_LOGO} alt="Vitalis Sports" className="h-10" />
        </Link>
        <nav className="hidden lg:flex items-center gap-1">
          <Link to="/fitness" className="flex items-center gap-1 px-4 py-2 text-gray-700 hover:text-orange-500 font-medium">Fitness <ChevronDown className="h-4 w-4" /></Link>
          <Link to="/racket" className="flex items-center gap-1 px-4 py-2 text-gray-700 hover:text-orange-500 font-medium">Racket <ChevronDown className="h-4 w-4" /></Link>
          <Link to="/wellness" className="px-4 py-2 text-orange-500 font-medium">Wellness</Link>
          <Link to="/ueber-uns" className="flex items-center gap-1 px-4 py-2 text-gray-700 hover:text-orange-500 font-medium">Über uns <ChevronDown className="h-4 w-4" /></Link>
          <Link to="/kontakt" className="px-4 py-2 text-gray-700 hover:text-orange-500 font-medium">Kontakt</Link>
        </nav>
        <div className="flex items-center gap-4">
          <a href="https://www.courtsonline.ch/?a=Ng==" target="_blank" rel="noopener noreferrer" className="hidden sm:block bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded font-bold text-sm">PLATZ BUCHEN</a>
          <button onClick={() => setMenuOpen(!menuOpen)} className="lg:hidden p-2 hover:bg-gray-100 rounded">{menuOpen ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}</button>
        </div>
      </header>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="fixed inset-0 bg-white z-40 pt-20 lg:hidden overflow-y-auto">
          <nav className="flex flex-col py-4">
            <Link to="/fitness" onClick={() => setMenuOpen(false)} className="px-6 py-4 text-xl font-bold text-gray-800 hover:text-orange-500 border-b border-gray-100">Fitness</Link>
            <Link to="/racket" onClick={() => setMenuOpen(false)} className="px-6 py-4 text-xl font-bold text-gray-800 hover:text-orange-500 border-b border-gray-100">Racket</Link>
            <Link to="/wellness" onClick={() => setMenuOpen(false)} className="px-6 py-4 text-xl font-bold text-orange-500 border-b border-gray-100">Wellness</Link>
            <Link to="/ueber-uns" onClick={() => setMenuOpen(false)} className="px-6 py-4 text-xl font-bold text-gray-800 hover:text-orange-500 border-b border-gray-100">Über uns</Link>
            <Link to="/kontakt" onClick={() => setMenuOpen(false)} className="px-6 py-4 text-xl font-bold text-gray-800 hover:text-orange-500 border-b border-gray-100">Kontakt</Link>
            <Link to="/" onClick={() => setMenuOpen(false)} className="px-6 py-4 text-xl font-bold text-gray-800 hover:text-orange-500 border-b border-gray-100">← Zurück</Link>
          </nav>
        </div>
      )}

      {/* Hero Section with Video */}
      <section className="relative h-[70vh] overflow-hidden">
        <div className="absolute inset-0">
          <iframe
            src="https://player.vimeo.com/video/1026390854?background=1&autoplay=1&loop=1&muted=1"
            className="absolute w-[177.77vh] min-w-full min-h-full top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
            frameBorder="0"
            allow="autoplay; fullscreen"
            title="Wellness Video"
          />
          <div className="absolute inset-0 bg-black/40" />
        </div>
        <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4">
          <h1 className="text-6xl md:text-8xl font-black text-orange-500 drop-shadow-lg">Entspannung pur</h1>
          <p className="text-white text-xl mt-4 tracking-widest uppercase">entspannt saunieren</p>
        </div>
      </section>

      {/* Sauna Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="aspect-video rounded-xl overflow-hidden shadow-lg">
              <img src="https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800&q=80" alt="Sauna" className="w-full h-full object-cover" />
            </div>
            <div>
              <h2 className="text-4xl font-black text-gray-900 mb-6">Sauna</h2>
              <p className="text-gray-600 text-lg leading-relaxed">
                Die Sauna bietet Ihnen nach dem Training die ideale Möglichkeit zur Entspannung und Regeneration. 
                Mit wohltuender Wärme unterstützt sie nicht nur die Muskulatur bei der Erholung, sondern stärkt auch 
                das Immunsystem und fördert die Durchblutung. Genießen Sie das entspannte Ambiente und lassen Sie 
                die Anspannung des Alltags hinter sich – ein wertvoller Ausgleich für Körper und Geist.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Öffnungszeiten */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-4xl font-black text-gray-900 text-center mb-12">Öffnungszeiten</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-xl p-6 shadow-sm">
              <h3 className="text-xl font-bold text-orange-500 mb-4">Winter Sept. - April</h3>
              <ul className="space-y-2 text-gray-700">
                <li className="flex justify-between"><span>Montag - Freitag</span><span>13:30 – 21:30</span></li>
                <li className="flex justify-between"><span>Donnerstag</span><span className="text-orange-500">Damensauna</span></li>
                <li className="flex justify-between"><span>Samstag / Sonntag</span><span>09:30 – 15:45</span></li>
              </ul>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm">
              <h3 className="text-xl font-bold text-orange-500 mb-4">Sommer Mai - Sept.</h3>
              <ul className="space-y-2 text-gray-700">
                <li className="flex justify-between"><span>Montag - Freitag</span><span>13:30 – 20:45</span></li>
                <li className="flex justify-between"><span>Donnerstag</span><span className="text-orange-500">Damensauna</span></li>
                <li className="flex justify-between"><span>Samstag</span><span>09:30 – 12:45</span></li>
                <li className="flex justify-between"><span>Sonntag</span><span className="text-gray-400">geschlossen</span></li>
              </ul>
            </div>
          </div>
          <p className="text-center text-gray-500 text-sm mt-6">
            Spezielle Öffnungszeiten an Feiertagen für Sauna. Siehe entsprechender Aushang vor Feiertagen am Empfang.
          </p>
        </div>
      </section>

      {/* Preise */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-4xl font-black text-gray-900 text-center mb-12">Preise</h2>
          <div className="bg-gray-50 rounded-xl overflow-hidden">
            <table className="w-full">
              <thead>
                <tr className="bg-[#1e3a5f] text-white">
                  <th className="text-left py-4 px-6 font-bold">Abovariante</th>
                  <th className="text-right py-4 px-6 font-bold">Preis</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-gray-200">
                  <td className="py-4 px-6 text-gray-700">Einzeleintritt</td>
                  <td className="py-4 px-6 text-right font-bold text-gray-900">26 Fr.</td>
                </tr>
                <tr className="border-b border-gray-200 bg-white">
                  <td className="py-4 px-6">
                    <div className="text-gray-700">11er Abo</div>
                    <div className="text-sm text-gray-500">gültig 12 Monate</div>
                  </td>
                  <td className="py-4 px-6 text-right font-bold text-gray-900">260 Fr.</td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="py-4 px-6">
                    <div className="text-gray-700">Halbjahresabo</div>
                    <div className="text-sm text-gray-500">gültig 6 Monate</div>
                  </td>
                  <td className="py-4 px-6 text-right font-bold text-gray-900">450 Fr.</td>
                </tr>
                <tr className="bg-white">
                  <td className="py-4 px-6">
                    <div className="text-gray-700">Ganzjahresabo</div>
                    <div className="text-sm text-gray-500">gültig 12 Monate</div>
                  </td>
                  <td className="py-4 px-6 text-right font-bold text-gray-900">660 Fr.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-black text-gray-900">Das sagen unsere Member</h2>
          </div>
          <TestimonialSlider />
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-12">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            <div>
              <img src={VITALIS_LOGO} alt="Vitalis Sports" className="h-10 mb-4 brightness-0 invert opacity-70" />
              <p className="text-sm">Dein familiäres Fitness- und Sportcenter im Rheintal.</p>
            </div>
            <div>
              <h4 className="font-bold text-white mb-4">Angebot</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/fitness" className="hover:text-white">Fitness</Link></li>
                <li><Link to="/racket" className="hover:text-white">Racket</Link></li>
                <li><Link to="/wellness" className="hover:text-white">Wellness</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold text-white mb-4">Kontakt</h4>
              <ul className="space-y-2 text-sm">
                <li>Rorschacherstrasse 43</li>
                <li>9450 Lüchingen/Altstätten</li>
                <li>+41 71 755 50 66</li>
                <li>info@vitalis-sports.ch</li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold text-white mb-4">Extranet</h4>
              <p className="text-sm mb-4">Mitarbeiter-Bereich</p>
              <Link to="/login" className="inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded text-sm font-medium">
                <Users className="h-4 w-4" />
                Anmelden
              </Link>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm">© 2026 Vitalis Sports</p>
            <div className="flex gap-6 text-sm">
              <a href="https://vitalis-sports.ch/impressum/" target="_blank" rel="noopener noreferrer" className="hover:text-white">Impressum</a>
              <a href="https://vitalis-sports.ch/datenschutzerklaerung/" target="_blank" rel="noopener noreferrer" className="hover:text-white">Datenschutz</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
